import { Subcategory } from "../../../Models/SubCategory";
import { BaseAPICallsHandler } from "../BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkUtils";
import { ServerConfig } from "../ServerConfig";


export interface SubcategoriesResponse {
    subcategories: Subcategory[]
    totalSubcategories: Number
    pageNumber: Number
    pageSize: Number
}

export class SubcategoryAPIHandler {
    
    public static shared = new SubcategoryAPIHandler()
    
    apiHandler = BaseAPICallsHandler.shared
    serverConfig = ServerConfig.shared
    networkUtils = NetworkUtils.shared

    // dependency injection here
    constructor();
    constructor(apiHandler: BaseAPICallsHandler, serverConfig: ServerConfig, networkUtils: NetworkUtils);
    public constructor(...params: any[]) {
        if(params.length >= 3) {
            this.apiHandler = params[0];
            this.serverConfig = params[1];
            this.networkUtils = params[2];
        }
    };

    public async getAllSubcategories(pageNumber: Number = 1, pageSize: Number = 20): Promise<SubcategoriesResponse> {
        let queryParams = new URLSearchParams();
        queryParams.append('pageNumber', pageNumber.toString());
        queryParams.append('pageSize', pageSize.toString());
    
        let url = this.serverConfig.subCategoriesAPIs.subcategoriesAPI + `?${queryParams.toString()}`;
    
        try {
            let response = await this.apiHandler.makeGetRequest({}, url);
            let data = response.data.subcategories as Array<any>;
    
            let subcategoriesArray = data.map((subcategory) => {
                return new Subcategory(subcategory);
            });
    
            let responseToSendBack: SubcategoriesResponse = {
                subcategories: subcategoriesArray,
                pageNumber: response.data.pageNumber,
                pageSize: response.data.pageSize,
                totalSubcategories: response.data.totalSubcategories
            };
    
            return Promise.resolve(responseToSendBack);
        } catch (err) {
            return Promise.reject(err);
        }
    }
    

    public async getSubcategoryById(Id: String): Promise<Subcategory> {
        let url = this.serverConfig.subCategoriesAPIs.subcategoriesAPI + Id;
        
        try {
            
            let response = await this.apiHandler.makeGetRequest({}, url);
            let data = response.data;
            let subcategory = new Subcategory(data);
            return Promise.resolve(subcategory);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async getSubcategoriesForCategory(categoryId: string, pageNumber: Number = 1, pageSize: Number = 20): Promise<SubcategoriesResponse> {
        let queryParams = new URLSearchParams();
        queryParams.append('pageNumber', pageNumber.toString());
        queryParams.append('pageSize', pageSize.toString());
    
        let url = this.serverConfig.subCategoriesAPIs.getSubcategoriesFromCategoryURL(categoryId) + `?${queryParams.toString()}`;
    
        try {
            let response = await this.apiHandler.makeGetRequest({}, url);
            let data = response.data.subcategories as Array<any>;
    
            let subcategoriesArray = data.map((subcategory) => {
                return new Subcategory(subcategory);
            });
    
            let responseToSendBack: SubcategoriesResponse = {
                subcategories: subcategoriesArray,
                pageNumber: response.data.pageNumber,
                pageSize: response.data.pageSize,
                totalSubcategories: response.data.totalSubcategories
            };
    
            return Promise.resolve(responseToSendBack);
        } catch (err) {
            return Promise.reject(err);
        }
    }
    

    public async postNewSubcategory(categoryId: string, subcategoryData: any): Promise<Subcategory> {
        let url = this.serverConfig.subCategoriesAPIs.getSubcategoriesFromCategoryURL(categoryId);
        let adminAuthHeaders = this.networkUtils.addAdminAuthHeaders({});
        try {
            
            let response = await this.apiHandler.makePostRequest(adminAuthHeaders, url, subcategoryData);
            let data = response.data;
            let subcategory = new Subcategory(data);
            return Promise.resolve(subcategory);

        } catch (err) {
            return Promise.reject(err);
        }
    }
    
    public async updateSubcategoryById(subcategoryData: any, subcategoryId: String): Promise<Subcategory> {
        let url = this.serverConfig.subCategoriesAPIs.subcategoriesAPI + subcategoryId;
        let adminAuthHeaders = this.networkUtils.addAdminAuthHeaders({});
        try {
            
            let response = await this.apiHandler.makePutRequest(adminAuthHeaders, url, subcategoryData);
            let data = response.data;
            let subcategory = new Subcategory(data);
            return Promise.resolve(subcategory);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async deleteSubcategoryById(subcategoryId: String): Promise<String> {
        let url = this.serverConfig.subCategoriesAPIs.subcategoriesAPI + subcategoryId;
        let adminAuthHeaders = this.networkUtils.addAdminAuthHeaders({});

        try {
            
            let response = await this.apiHandler.makeDeleteRequest(adminAuthHeaders, url, {});
            let responseMessage = response.data.message;
            return Promise.resolve(responseMessage);

        } catch (err) {
            return Promise.reject(err);
        }
    }

}
